import * as styles from './index.module.scss';

import React from 'react';
import Link from 'next/link';

import { CATEGORY_SUBSETS } from '@/contexts/categories_subset';

const PopularCategoriesByCity = (props) => (
  <div className={`${styles['popular-categories-by-city-container']}`}>
    <div className="container">
      <h3>Popular Categories</h3>
      <ul className={styles['city-links-container']}>
        {CATEGORY_SUBSETS.filter((category) => !category.exclude_from_popular_categories).map((category) => (
          <li key={category.name}>
            <Link href={`/us/${props.state.toLowerCase()}/${props.city.toLowerCase()}/${category.url_slug}`}>{category.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default PopularCategoriesByCity;
